import React from "react";
import "../footer/footer.css";

const Footer = () => {
  return (
    <section id="footer" className="footer">
      <div className="container">
        <h2 className="display-thank">Thank You</h2>
        <p className="mb-0 display-copyright">Naresy International Education Consultant</p>
        <p className="mb-0">{new Date().getFullYear()} © NIEC Indonesia</p>
      </div>
    </section>
  );
};

export default Footer;
